// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';
import dayjs from 'dayjs';

import { css } from '@emotion/css';
import { Theme, Typography, useTheme } from '@mui/material';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

// TYPES ---------------------------------------------------------------- //

interface TimelineAreaMarkerCurrentProps {
  showLabel: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TimelineAreaMarkerCurrent = ({ showLabel }: TimelineAreaMarkerCurrentProps) => {
  const theme = useTheme();
  const cls = useStyles(theme);
  const clsx = useSxStyles(theme);

  const { timezoneOverride, currentPosition, currentTime } = useTimeline();

  return (
    <div className={cls.timelineAreaMarker} style={{ left: currentPosition }}>
      <div className={cls.line} />

      {showLabel ? (
        <div className={cls.label}>
          <Typography sx={clsx.labelTxt}>{dayjs(currentTime).tz(timezoneOverride).format(`h:mm A z`)}</Typography>
        </div>
      ) : null}
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  timelineAreaMarker: css`
    z-index: 402;
    position: absolute;
    display: flex;
    top: 0;
    height: 100%;
    user-select: none;
    pointer-events: none;
  `,

  line: css`
    border-left: 1px solid ${theme.palette.error.main};
    height: 100%;
    box-shadow: 0px 0px 1px #ffffff;
  `,

  label: css`
    display: flex;
    flex-direction: column;
    gap: 2px;
    height: fit-content;
    padding: 3px;
    border-radius: 0 0 4px 0;
    background: ${theme.palette.error.main};
  `,
});

const useSxStyles = (theme: Theme) => ({
  labelTxt: {
    whiteSpace: 'nowrap',
    lineHeight: 1,
    fontSize: '10px',
    fontWeight: 500,
    color: theme.palette.text.contrastPrimary,
  },
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineAreaMarkerCurrent;
